import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { GetWithdrawalTransactionsByIdResponse } from '@/modules/transaction/types'
import { queryWithdrawTransactionsByIdOptions } from './options'

export default function useQueryWithdrawTransactionsById(
	id: string,
	options?: UseBaseQueryOptions<GetWithdrawalTransactionsByIdResponse>,
) {
	return useQuery(queryWithdrawTransactionsByIdOptions(id, options))
}
